import React, { useRef } from "react";
import InstallmentHtmlTable, { InstallmentHtmlTableRefProps } from "../InstallmentHtmlTable";
import { toast } from "react-toastify";


type Props = {
    paymentAmount: string,
    licenseKey: string,
    taxCode: string
}
const HtmlTableButton = (props: Props) => {

    const { licenseKey, paymentAmount, taxCode } = props;
    const installmentHtmlTableRef = useRef<InstallmentHtmlTableRefProps>(null);


    const showInstallmentHtmlTable = () => {

        const amount = paymentAmount ? paymentAmount.toString().replaceAll(",", '').replaceAll(".", '') : "0";
        if (parseInt(amount) > 0) {
            installmentHtmlTableRef.current?.openModal(paymentAmount);
        } else {
            toast.error("Lütfen tutar giriniz.");
        }

    }


    return (
        <div>
            <InstallmentHtmlTable hideAmountInput licenseKey={licenseKey} taxCode={taxCode} ref={installmentHtmlTableRef} />

            <div onClick={showInstallmentHtmlTable}
                className=" w-full cursor-pointer text-center text-blue-700 text-[13px] font-medium  underline mt-6">Tüm Taksit Seçeneklerini Gör</div>
        </div>
    );
}
export default HtmlTableButton;